export default __webpack_public_path__ + "static/analyticsplay-cf66200a4da485ae72cef13d9ced2de6.png";